import type { EntityActionType } from '../type';

export const entityActions: Record<EntityActionType, EntityActionType> = {
  reset: 'reset',
  archive: 'archive',
  rollback: 'rollback',
};
